const TRANSLATIONS_COMMON_DB_FIELD_NAME = 'translations'
const transDynamic = (varObj: any, args: string): string => {
  try {
    const [field, languageIso, needTranslate] = args.split(',')

    if (!varObj || !field) {
      return ''
    }

    const untranslatedValue = varObj[field] || ''

    if (needTranslate !== 'true' || !languageIso) {
      return untranslatedValue
    }

    const translations = varObj[TRANSLATIONS_COMMON_DB_FIELD_NAME] || {}

    return translations[`${field}_${languageIso}`] || untranslatedValue
  } catch { /* */ }

  return ''
}

export default transDynamic
